import { useTreatmentPlanTemplateQuery } from "@api/graphql/types-and-hooks";
import { useReport } from "@providers/ReportProvider";

export function useIsGasEnabled(): boolean {
  const { report } = useReport();
  const reportId = report?.id ?? "";

  const treatmentPlanTemplateQuery = useTreatmentPlanTemplateQuery(
    { reportId },
    {
      enabled: !!reportId,
      retry: false,
    },
  );

  return treatmentPlanTemplateQuery.data?.treatmentPlanTemplate?.isGasEnabled ?? false;
}
